module.exports = __webpack_public_path__ + "static/media/linkedIn-ice-blue.55ffd870.svg";